export const PIN_MARKER_GREEN = 'green-02';
export const PIN_MARKER_BASE = 'base-01';
export const PIN_MARKER_ORANGE = 'orange-01';
export const PIN_MARKER_YELLOW = 'yellow-01';
export const PIN_MARKER_RED = 'red-01';
export const PIN_MARKER_GRAY = 'gray-04';
export const PIN_MARKER_BLUE = 'blue-01';
